import axiosInst from 'api/axios';
import { AllRoutes } from 'constants/routes';
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from 'redux/appReducer';
import styles from './Accounts.module.scss';
import { SingleAccount } from './SingleAccount';

const ITEMS_PER_RAGE = 10;

export const Albaran = () => {
  const { state, getAccounts, getAccountsCount } = useContext(AppContext);

  const navigate = useNavigate();

  const handleAddClick = () => {
    navigate(AllRoutes.addAccount);
  };

  useEffect(() => {
    axiosInst()
      .get('/accounts')
      .then((res) => {
        getAccounts(res.data?.accounts);
        getAccountsCount(res.data?.count);
      })
      .catch((e) => console.log(e));
  }, []);

  const showMore = () => {
    axiosInst()
      .get(`/accounts?offset=${state.accounts.length}&limit=${ITEMS_PER_RAGE}`)
      .then((res) => {
        getAccounts([...state.accounts, ...res.data?.accounts]);
      })
      .catch((e) => console.log(e));
  };

  return (
    <>
      <div className={styles.container}>
        <button className={styles.addBtn} onClick={handleAddClick}>
          + <span>ALBARÁN</span>
        </button>
        <table className={styles.table}>
          <thead className={styles.thead}>
            <tr>
              <th>№ Albarán</th>
              <th>№ Factura</th>
              <th>Fecha</th>
              <th>Cliente</th>
              <th>total</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {state.accounts.map((item) => (
              <SingleAccount key={item.id} item={item} />
            ))}
          </tbody>
        </table>
        {state.accounts.length < state.count && (
          <div className={styles.more} onClick={showMore}>
            <div className={styles.arrow}></div>
          </div>
        )}
      </div>
    </>
  );
};
